import { useCallback, useState } from 'react';

import { hasHeroMatch } from '../../../telemetry/hero';
import { ReportHeroComponentRendered } from '../context';

import { UsePageLoadTelemetryCallbackOptions, usePageLoadTelemetryCallback } from './usePageLoadTelemetryCallback';

export type UseReportHeroComponentRenderedCallback = (options: UsePageLoadTelemetryCallbackOptions) => {
  readonly reportHeroComponentRendered: ReportHeroComponentRendered;
  readonly hasHeroComponentRendered: boolean;
};
export const useReportHeroComponentRenderedCallback: UseReportHeroComponentRenderedCallback = (options) => {
  const [hasHeroComponentRendered, setHeroComponentRendered] = useState(false);

  const pageLoadTelemetryCallback = usePageLoadTelemetryCallback(options);

  const { hero } = options;
  const reportHeroComponentRendered: ReportHeroComponentRendered = useCallback(
    (component, heroOptions) => {
      if (hasHeroMatch(component, hero)) {
        setHeroComponentRendered(true);
      }
      pageLoadTelemetryCallback(component, heroOptions);
    },
    [hero, pageLoadTelemetryCallback]
  );

  return { reportHeroComponentRendered, hasHeroComponentRendered };
};
